export type OrgNodeKind = "leadership" | "division" | "unit" | "team" | "key_persons";

export interface OrgRole {
    id: string;
    label: string;
}

export interface OrgPerson {
    id: string;
    name: string;
    role_id: string;
}

export interface OrgNode {
    id: string;
    kind: OrgNodeKind;
    parent_id: string | null;
    title: string;
    description: string;
    people: OrgPerson[];
}

export interface CompanyOrgStructureDocument {
    schema_version: number;
    roles: OrgRole[];
    nodes: OrgNode[];
    updated_at?: number;
    updated_by?: string;
}

export const EMPTY_ORG_STRUCTURE_DOCUMENT: CompanyOrgStructureDocument = {
    schema_version: 1,
    roles: [],
    nodes: []
};

export const ORG_NODE_KINDS: OrgNodeKind[] = [
    "leadership",
    "division",
    "unit",
    "team",
    "key_persons"
];
